import {Injectable} from '@angular/core';

// eslint-disable-next-line no-underscore-dangle,prefer-arrow/prefer-arrow-functions
function _window(): any {
    // return the global native browser window object
    return window;
}

@Injectable({
    providedIn: 'root'
})
export class WindowRefService {
    get nativeWindow(): any {
        return _window();
    }
}
